import { render, staticRenderFns } from "./production_notes.vue?vue&type=template&id=7f9cf56b&scoped=true&"
import script from "./production_notes.vue?vue&type=script&lang=js&"
export * from "./production_notes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9cf56b",
  null
  
)

export default component.exports